import React from "react";
import { Form } from "antd";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import CaseLawDocumentTypeForm from "./CaseLawDocumentTypeForm";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import TickBox from "../../../core/ui/components/grid/TickBox";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
interface CaseLawDocumentTypeGridProps {
  translate: any;
  caseLawDocumentTypes: IDocumentType[];
  createCaseLawDocumentType: any;
  referenceLoader?: boolean;
  updateCaseLawDocumentType;
}
const CaseLawDocumentTypeGrid: React.FC<CaseLawDocumentTypeGridProps> = ({
  translate,
  caseLawDocumentTypes,
  createCaseLawDocumentType,
  referenceLoader,
  updateCaseLawDocumentType
}) => {
  const builder = DataGridConfigurationBuilder({
    translate,
    resourcePrefix: "editors.case_law_document_types"
  });
  const columns = builder.buildColumns("code", "name", "description", {
    name: "valid",
    dataKey: "valid",
    sortable: false,
    align: "center",
    render: (record) => <TickBox value={record.valid} />
  });

  const [CreateForm] = Form.useForm();
  const [UpdateForm] = Form.useForm();

  return (
    <DataGrid
      title={translate("editors.case_law_document_types.title")}
      columns={columns}
      translate={translate}
      dataSource={caseLawDocumentTypes || []}
      allowCreate={true}
      allowUpdate={true}
      addButtonText={translate("editors.case_law_document_types.add_new_text")}
      createForm={
        <CaseLawDocumentTypeForm translate={translate} form={CreateForm} />
      }
      updateForm={
        <CaseLawDocumentTypeForm translate={translate} form={UpdateForm} />
      }
      createModalTitle={`${translate(
        "editors.case_law_document_types.create_modal_title"
      )}`}
      updateModalTitle={`${translate(
        "editors.case_law_document_types.update_modal_title"
      )}`}
      loading={referenceLoader}
      onCreate={(e) => {
        createCaseLawDocumentType(e);
      }}
      onUpdate={updateCaseLawDocumentType}
      booleanColumnKeys={["valid"]}
      createModalClass={"modal-width"}
      updateModalClass={"modal-width"}
      keyProperty={"id"}
      CreateFormInstance={CreateForm}
      UpdateFormInstance={UpdateForm}
      createActionPosition={"topRight"}
    />
  );
};
export default CaseLawDocumentTypeGrid;
